const EditorialPolicy = () => {
  return (
    <>
      <div className="policy-wrapper bg-white overflow-hidden">
         <div className="w-screen h-64 md:h-[430px] border-[3px] border-[#35A93E]">
          <img
            src="/editorial.jpeg"
            alt="Editorial Banner"
            className="w-full h-full object-contain md:object-contain"
          />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 my-6">
          <div className="border-b border-gray-200 pb-6 mb-10">
            <h1 className="text-2xl font-bold text-gray-900">Editorial Policy</h1>
            <p className="text-sm text-gray-500 mt-4">
              Effective Date: 01.07.2025
            </p>
            <p className="text-sm text-gray-500 mt-2">
              Contact: <a href="mailto:content@lifeonplus.com" className="text-blue-600 hover:underline">content@lifeonplus.com</a> | <a href="mailto:legal@lifeonplus.com" className="text-blue-600 hover:underline">legal@lifeonplus.com</a>
            </p>
          </div>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Purpose</h2>
            <p className="text-base text-gray-700 leading-7">
              This Editorial Policy outlines the principles and practices LifeOnPlus follows in creating and publishing health-related content, blog posts, product/service descriptions, medical information, and promotional material on our digital platforms.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Editorial Mission</h2>
            <p className="text-base text-gray-700 leading-7">
              LifeOnPlus aims to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-7 mt-2">
              <li className="mb-2">Educate users about preventive health, wellness, and digital health tools.</li>
              <li className="mb-2">Empower individuals with reliable, accessible, and non-invasive healthcare content.</li>
              <li className="mb-2">Bridge the gap between medical literacy and technology through simplified explanations.</li>
              <li className="mb-2">Maintain neutrality, accuracy, and inclusivity in all published material.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Content Types Covered</h2>
            <p className="text-base text-gray-700 leading-7">
              This policy applies to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-7 mt-2">
              <li className="mb-2">Health and wellness blogs.</li>
              <li className="mb-2">Preventive care awareness articles.</li>
              <li className="mb-2">Product/service descriptions.</li>
              <li className="mb-2">Social media content.</li>
              <li className="mb-2">Medical device usage guidelines.</li>
              <li className="mb-2">Member communications, newsletters.</li>
              <li className="mb-2">Franchise/investment-related documents.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Content Sourcing and Validation</h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">All health content is sourced from credible references such as peer-reviewed journals, government health agencies (e.g., ICMR, WHO), and certified medical professionals.</li>
              <li className="mb-2">Medical advice or claims are reviewed by qualified healthcare professionals where applicable.</li>
              <li className="mb-2">We cite sources where needed and avoid anecdotal or unverified information.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Editorial Review & Approvals</h2>
            <p className="text-base text-gray-700 leading-7">
              Each content piece goes through a 3-tier editorial review process:
            </p>
            <ul className="list-decimal pl-6 text-gray-700 leading-7 mt-2">
              <li className="mb-2">Content Creator (writer or expert).</li>
              <li className="mb-2">Internal Reviewer (editor or medical advisor).</li>
              <li className="mb-2">Compliance & Legal Team (if applicable).</li>
            </ul>
            <p className="text-base text-gray-700 leading-7 mt-2">
              Content on medical procedures, diagnostics, and body analysis tools is cleared by certified practitioners before publication.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Language & Tone</h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">All content is written in a clear, simple, and user-friendly tone.</li>
              <li className="mb-2">Technical terms are explained in layman’s language where possible.</li>
              <li className="mb-2">Content is available in English and select regional languages (Hindi, Tamil, Kannada, etc.) for accessibility.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Independence and Impartiality</h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">We do not allow advertiser influence over editorial decisions.</li>
              <li className="mb-2">Sponsored content is clearly marked and adheres to the same editorial standards.</li>
              <li className="mb-2">We do not promote unverified health claims or miracle cures.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Content Updates and Corrections</h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">Information in health and technology evolves. We review major content at least once every 6 months.</li>
              <li className="mb-2">Corrections, if any, are made transparently with updated timestamps.</li>
              <li className="mb-2">Users can report inaccuracies at <a href="mailto:content@lifeonplus.com" className="text-blue-600 hover:underline">content@lifeonplus.com</a>.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Compliance with Regulatory Standards</h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">All content complies with Indian laws related to advertising, medical content (Drugs and Magic Remedies Act, IT Act, etc.).</li>
              <li className="mb-2">Any claims made in relation to therapies, diagnostics, or devices are aligned with approvals or permitted usage norms.</li>
              <li className="mb-2">Prescription products or invasive health advice are never recommended without clinical backing.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. User-Generated Content</h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">Testimonials, comments, and reviews submitted by users are moderated for authenticity and relevance.</li>
              <li className="mb-2">We reserve the right to edit or remove offensive, misleading, or inappropriate submissions.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Editorial Team and Expert Contributors</h2>
            <p className="text-base text-gray-700 leading-7">
              Our content is developed by a team of:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-7 mt-2">
              <li className="mb-2">Health writers, editors, and content strategists.</li>
              <li className="mb-2">Doctors, wellness experts, physiotherapists, nutritionists, and medical advisors.</li>
              <li className="mb-2">Compliance experts ensuring legal accuracy.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. Contact and Grievance Redressal</h2>
            <p className="text-base text-gray-700 leading-7">
              For feedback, suggestions, or editorial concerns, contact:
            </p>
            <p className="text-base text-gray-700 leading-7 mt-3">
              <strong>Editorial Desk</strong><br />
              Email: <a href="mailto:content@lifeonplus.com" className="text-blue-600 hover:underline">content@lifeonplus.com</a><br />
              <strong>Legal & Compliance</strong><br />
              Email: <a href="mailto:legal@lifeonplus.com" className="text-blue-600 hover:underline">legal@lifeonplus.com</a><br />
              Address: Lifeonplus Technologies India Private Limited, No.301, 3rd Floor, “Master Mind 1, Royal Palms”, Aarey Milk Colony, Goregaon (East), Mumbai-400065<br />
              Contact lash; Contact: 📞 <a href="tel:+919986880000" className="text-blue-600 hover:underline">99868 80000</a> | ✉️ <a href="mailto:info@lifeonplus.com" className="text-blue-600 hover:underline">info@lifeonplus.com</a>
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default EditorialPolicy;